import { render, staticRenderFns } from "./CapacidadeCaixaFormCarga.vue?vue&type=template&id=24a78165&"
import script from "./CapacidadeCaixaFormCarga.vue?vue&type=script&lang=js&"
export * from "./CapacidadeCaixaFormCarga.vue?vue&type=script&lang=js&"
import style0 from "./CapacidadeCaixaFormCarga.vue?vue&type=style&index=0&id=24a78165&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports